"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteReplayItem = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const server_1 = require("../../../../../server");
const popup_1 = require("../../../../base/popup");
const DeletePopUpLayout_1 = require("../../../../base/layout/DeletePopUpLayout");
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const DeleteReplayItem = ({ isOneDel, deleteList, menu, styles, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const deleteReplayMutation = (0, react_query_1.useMutation)(server_1.deleteReplay);
    const onDelete = async () => {
        const successfulDeletes = [];
        const failedDeletes = [];
        const deleteHandler = async (id) => {
            try {
                await deleteReplayMutation.mutateAsync(id);
                successfulDeletes.push(id);
            }
            catch (error) {
                failedDeletes.push(id);
            }
        };
        try {
            const deletePromises = deleteList.map(id => deleteHandler(id));
            await Promise.all(deletePromises);
        }
        catch (error) {
            alert(error);
        }
        finally {
            // Log successful and failed deletions
            // if (successfulDeletes.length) {
            // 	console.log('Successfully deleted ids:', successfulDeletes);
            // }
            // if (failedDeletes.length) {
            // 	console.error('Failed to delete ids:', failedDeletes);
            // }
            // Refresh the contents
            APP.eventManager.publish('REFRESH_REPLAY_LIST');
        }
    };
    const handlerDel = () => {
        if (deleteList.length <= 0)
            return;
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DeletePopUpLayout_1.DeletePopUpLayout,
            componentProps: {
                deleteContent: deleteList.length
                    ? isMobile
                        ? t('assignment.delteIntoMobile', { count: deleteList?.length })
                        : t('assignment.delteInto', { count: deleteList?.length })
                    : t('common.notSelect'),
                onDelete: onDelete,
            },
            width: isTablet ? 480 : isMobile ? 300 : 639,
            title: t(`conference.${menu}Delete`),
            isFit: true,
        });
    };
    if (isOneDel) {
        return (react_1.default.createElement(common_1.Button, { option: {
                buttonAfterIcon: {
                    show: true,
                    name: 'delete',
                    size: 20,
                },
            }, onClick: () => handlerDel() }));
    }
    return (react_1.default.createElement(common_1.Button, { text: "common.delete", className: `btn_default ${isMobile ? 'mobile-xs' : isTablet ? 'sm' : 'xmd'}`, onClick: handlerDel, styles: { buttonWrap: styles } }));
};
exports.DeleteReplayItem = DeleteReplayItem;
